/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Mobile Dropdown Functionality
  class MobileDropdown {
    constructor() {
      console.log('MobileDropdown constructor called');
      this.dropdowns = document.querySelectorAll('.mobile-dropdown');
      console.log('Found dropdowns:', this.dropdowns.length);
      this.init();
    }

    init() {
      this.dropdowns.forEach((dropdown, index) => {
        const toggle = dropdown.querySelector('.mobile-dropdown__toggle');
        const content = dropdown.querySelector('.mobile-dropdown__content');
        
        console.log(`Dropdown ${index}:`, {toggle, content});
        
        if (toggle && content) {
          this.setupDropdown(toggle, content, dropdown);
        }
      });
    }

    setupDropdown(toggle, content, dropdown) {
      console.log('Setting up dropdown with toggle:', toggle);
      
      // Remove any existing listeners
      const newToggle = toggle.cloneNode(true);
      toggle.parentNode.replaceChild(newToggle, toggle);
      
      // Toggle dropdown on click
      newToggle.addEventListener('click', (e) => {
        console.log('Dropdown clicked!');
        e.preventDefault();
        e.stopPropagation();
        
        const isExpanded = newToggle.getAttribute('aria-expanded') === 'true';
        console.log('Is expanded:', isExpanded);
        
        // Allow multiple dropdowns to be open at the same time
        if (isExpanded) {
          this.closeDropdown(newToggle, content);
        } else {
          this.openDropdown(newToggle, content);
        }
      });

      // Close dropdown when clicking outside
      document.addEventListener('click', (e) => {
        // For nested dropdowns, only close when clicking outside the main dropdown container
        if (dropdown.classList.contains('mobile-dropdown--nested')) {
          const mainDropdown = dropdown.closest('.mobile-dropdown:not(.mobile-dropdown--nested)');
          if (mainDropdown && !mainDropdown.contains(e.target)) {
            this.closeDropdown(newToggle, content);
          }
        } else {
          // For main dropdowns, close when clicking outside
          if (!dropdown.contains(e.target)) {
            this.closeDropdown(newToggle, content);
          }
        }
      });

      // Close dropdown on escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && newToggle.getAttribute('aria-expanded') === 'true') {
          this.closeDropdown(newToggle, content);
          newToggle.focus();
        }
      });
    }

    openDropdown(toggle, content) {
      console.log('openDropdown called', {toggle, content});
      toggle.setAttribute('aria-expanded', 'true');
      
      // Make content visible first
      content.style.visibility = 'visible';
      content.style.display = 'block';
      
      // Force a reflow to ensure content is measured correctly
      content.style.maxHeight = 'none';
      const height = content.scrollHeight;
      console.log('Calculated height:', height);
      content.style.maxHeight = '0px';
      
      // Trigger reflow
      content.offsetHeight;
      
      // Set the final height
      content.style.maxHeight = height + 'px';
      console.log('Set maxHeight to:', height + 'px');
      
      // Add animation classes
      setTimeout(() => {
        content.classList.add('is-open');
        
        // Ensure the menu container expands to accommodate the dropdown
        const menuContainer = content.closest('.drawer__menu');
        if (menuContainer) {
          menuContainer.style.minHeight = 'auto';
        }
      }, 10);
    }

    closeDropdown(toggle, content) {
      console.log('closeDropdown called');
      toggle.setAttribute('aria-expanded', 'false');
      content.style.maxHeight = '0px';
      content.classList.remove('is-open');
      
      // Close all nested dropdowns inside this dropdown
      const nestedDropdowns = content.querySelectorAll('.mobile-dropdown--nested');
      nestedDropdowns.forEach(nestedDropdown => {
        const nestedToggle = nestedDropdown.querySelector('.mobile-dropdown__toggle');
        const nestedContent = nestedDropdown.querySelector('.mobile-dropdown__content');
        
        if (nestedToggle && nestedContent && nestedToggle.getAttribute('aria-expanded') === 'true') {
          nestedToggle.setAttribute('aria-expanded', 'false');
          nestedContent.style.maxHeight = '0px';
          nestedContent.classList.remove('is-open');
          nestedContent.style.visibility = 'hidden';
        }
      });
      
      // Hide content after animation
      setTimeout(() => {
        content.style.visibility = 'hidden';
      }, 300);
    }

    closeAllDropdowns() {
      this.dropdowns.forEach(dropdown => {
        const toggle = dropdown.querySelector('.mobile-dropdown__toggle');
        const content = dropdown.querySelector('.mobile-dropdown__content');
        
        if (toggle && content && toggle.getAttribute('aria-expanded') === 'true') {
          this.closeDropdown(toggle, content);
        }
      });
    }

  }

  // Initialize mobile dropdowns when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      new MobileDropdown();
    });
  } else {
    new MobileDropdown();
  }

  // Re-initialize dropdowns when new content is loaded (e.g., after AJAX)
  document.addEventListener('shopify:section:load', () => {
    new MobileDropdown();
  });

  // ========================================
  // FIX: Garantir scroll no menu header desde a primeira abertura
  // ========================================
  class MenuScrollFix {
    constructor() {
      this.init();
    }

    init() {
      // Monitorar quando o drawer do header abre via evento
      document.addEventListener('theme:drawer:open', (e) => {
        const headerDrawer = e.target;
        
        // Verificar se é o drawer do header (menu mobile)
        if (headerDrawer && headerDrawer.classList.contains('drawer--header')) {
          console.log('🔧 Menu header aberto - garantindo scroll');
          
          // Habilitar scroll imediatamente
          this.enableScrollInDrawer(headerDrawer);
          
          // Forçar novamente após o scroll-lock ser aplicado
          setTimeout(() => {
            this.enableScrollInDrawer(headerDrawer);
          }, 50);
        }
      });

      // CRITICAL: Também monitorar mudanças de classe no drawer
      // Para pegar quando is-animated ou is-open é adicionado
      const headerDrawers = document.querySelectorAll('.drawer--header');
      
      headerDrawers.forEach(drawer => {
        const classObserver = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
              const classList = drawer.classList;
              
              // Se o drawer está abrindo (tem is-animated ou is-open)
              if (classList.contains('is-animated') || classList.contains('is-open')) {
                console.log('🔧 Classe de abertura detectada - ativando scroll');
                this.enableScrollInDrawer(drawer);
              }
            }
          });
        });
        
        classObserver.observe(drawer, {
          attributes: true,
          attributeFilter: ['class']
        });
      });
    }

    enableScrollInDrawer(drawer) {
      // Encontrar todos os elementos scrolláveis dentro do drawer
      const scrollableElements = drawer.querySelectorAll('[data-scroll-lock-scrollable]');
      
      console.log('📜 Elementos scrollable encontrados:', scrollableElements.length);
      
      scrollableElements.forEach(element => {
        // Garantir que o elemento pode fazer scroll
        element.style.cssText += `
          overflow: auto !important;
          overflow-y: auto !important;
          overflow-x: hidden !important;
          -webkit-overflow-scrolling: touch !important;
          touch-action: pan-y !important;
        `;
        
        // Forçar o navegador a reconhecer que o elemento deve fazer scroll
        const forceScroll = () => {
          element.scrollTop = element.scrollTop;
        };
        
        requestAnimationFrame(forceScroll);
      });
      
      // Também garantir scroll em elementos estruturais mesmo sem o atributo
      const drawerInner = drawer.querySelector('.drawer__inner');
      const drawerBody = drawer.querySelector('.drawer__body');
      const drawerContent = drawer.querySelector('.drawer__content');
      const drawerContentScroll = drawer.querySelector('.drawer__content__scroll');
      const drawerMenu = drawer.querySelector('.drawer__menu');
      const drawerMainMenu = drawer.querySelector('.drawer__main-menu');
      
      [drawerInner, drawerBody, drawerContent, drawerContentScroll, drawerMenu, drawerMainMenu].forEach(element => {
        if (element) {
          element.style.cssText += `
            overflow: auto !important;
            overflow-y: auto !important;
            overflow-x: hidden !important;
            -webkit-overflow-scrolling: touch !important;
            touch-action: pan-y !important;
            overscroll-behavior: contain !important;
          `;
          
          // Adicionar o atributo data-scroll-lock-scrollable se não existir
          if (!element.hasAttribute('data-scroll-lock-scrollable')) {
            element.setAttribute('data-scroll-lock-scrollable', '');
          }
          
          // CRITICAL: Forçar uma pequena interação para ativar o scroll
          element.scrollTop = 0;
        }
      });
      
      // CRITICAL: Monitorar mudanças de estilo que possam bloquear o scroll
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
            const element = mutation.target;
            
            // Se um dos nossos elementos scrolláveis teve o estilo modificado
            if (element.matches('.drawer__inner, .drawer__body, .drawer__content, .drawer__menu, [data-scroll-lock-scrollable]')) {
              // Verificar se o overflow foi bloqueado
              const computedStyle = window.getComputedStyle(element);
              if (computedStyle.overflowY === 'hidden' || computedStyle.overflow === 'hidden') {
                console.log('⚠️ Overflow bloqueado detectado, corrigindo...');
                
                // Forçar de volta
                element.style.cssText += `
                  overflow-y: auto !important;
                  -webkit-overflow-scrolling: touch !important;
                  touch-action: pan-y !important;
                `;
              }
            }
          }
        });
      });
      
      // Observar mudanças no drawer e seus filhos
      [drawerInner, drawerBody, drawerContent, drawerContentScroll, drawerMenu, drawerMainMenu].forEach(element => {
        if (element) {
          observer.observe(element, {
            attributes: true,
            attributeFilter: ['style', 'class']
          });
        }
      });
      
      console.log('✅ Scroll habilitado no menu header com proteção ativa');
    }
  }

  // Inicializar o fix de scroll do menu
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      new MenuScrollFix();
    });
  } else {
    new MenuScrollFix();
  }

  // ========================================
  // FIX ADICIONAL: Interceptar scroll-lock para permitir scroll no menu
  // ========================================
  (function() {
    // Interceptar o evento theme:scroll:lock antes que ele seja processado
    window.addEventListener('theme:scroll:lock', function(e) {
      // Verificar se o drawer do header está abrindo
      const headerDrawer = document.querySelector('.drawer--header.is-open, .drawer--header.is-animated');
      
      if (headerDrawer) {
        console.log('🔓 Interceptando scroll-lock para menu header');
        
        // Permitir scroll em elementos específicos do drawer
        setTimeout(() => {
          const scrollableSelectors = [
            '.drawer--header .drawer__inner',
            '.drawer--header .drawer__body',
            '.drawer--header .drawer__content',
            '.drawer--header .drawer__content__scroll',
            '.drawer--header .drawer__menu',
            '.drawer--header .drawer__main-menu',
            '[data-scroll-lock-scrollable]'
          ];
          
          scrollableSelectors.forEach(selector => {
            const elements = document.querySelectorAll(selector);
            elements.forEach(el => {
              // Forçar propriedades de scroll
              el.style.cssText += `
                overflow-y: auto !important;
                overflow-x: hidden !important;
                -webkit-overflow-scrolling: touch !important;
                touch-action: pan-y !important;
              `;
              
              // Garantir que o atributo existe
              el.setAttribute('data-scroll-lock-scrollable', '');
            });
          });
          
          console.log('✅ Scroll forçado em elementos do menu');
        }, 10);
      }
    }, true); // Use capture phase para executar antes
  })();
  
  // Mobile Drawer Controller
  class MobileDrawerController {
    constructor() {
      this.drawer = null;
      this.scrim = null;
      this.isOpen = false;
      this.focusableElements = [];
      this.lastFocusedElement = null;
      this.init();
    }

    init() {
      this.createScrim();
      this.setupEventListeners();
      this.observeDrawerChanges();
    }

    createScrim() {
      // Criar scrim se não existir
      if (!document.querySelector('.mobile-drawer-scrim')) {
        this.scrim = document.createElement('div');
        this.scrim.className = 'mobile-drawer-scrim';
        this.scrim.setAttribute('aria-hidden', 'true');
        document.body.appendChild(this.scrim);

        // Event listener para fechar ao clicar no scrim
        this.scrim.addEventListener('click', () => {
          this.closeDrawer();
        });
      } else {
        this.scrim = document.querySelector('.mobile-drawer-scrim');
      }
    }

    setupEventListeners() {
      // Listener para ESC key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen) {
          this.closeDrawer();
        }

        // Tab trap
        if (e.key === 'Tab' && this.isOpen) {
          this.handleTabKey(e);
        }
      });

      // Listener para botões de fechar
      document.addEventListener('click', (e) => {
        if (e.target.matches('.drawer__close, .drawer__close *')) {
          this.closeDrawer();
        }
      });
    }

    observeDrawerChanges() {
      // Observar mudanças nas classes do drawer
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            const target = mutation.target;
            
            // Verificar se é um drawer mobile (não header)
            if (target.matches('.drawer:not(.drawer--header)')) {
              this.drawer = target;
              
              if (target.classList.contains('is-open')) {
                this.openDrawer();
              } else if (target.classList.contains('is-closing') || !target.classList.contains('is-open')) {
                this.closeDrawer();
              }
            }
          }
        });
      });

      // Observar todos os drawers
      document.querySelectorAll('.drawer').forEach(drawer => {
        observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
      });
    }

    openDrawer() {
      if (this.isOpen) return;
      
      this.isOpen = true;
      this.lastFocusedElement = document.activeElement;

      // Bloquear scroll do body
      document.documentElement.classList.add('mobile-drawer-open');
      document.body.classList.add('mobile-drawer-open');

      // Mostrar scrim
      if (this.scrim) {
        this.scrim.classList.add('is-visible');
      }

      // Configurar elementos focáveis para tab trap
      this.setupFocusTrap();

      // Focus no primeiro elemento focável do drawer
      setTimeout(() => {
        this.focusFirstElement();
      }, 100);
    }

    closeDrawer() {
      if (!this.isOpen) return;
      
      this.isOpen = false;

      // Desbloquear scroll do body
      document.documentElement.classList.remove('mobile-drawer-open');
      document.body.classList.remove('mobile-drawer-open');

      // Esconder scrim
      if (this.scrim) {
        this.scrim.classList.remove('is-visible');
      }

      // Restaurar focus
      if (this.lastFocusedElement) {
        this.lastFocusedElement.focus();
        this.lastFocusedElement = null;
      }

      // Se o drawer ainda tem a classe is-open, forçar o close
      if (this.drawer && this.drawer.classList.contains('is-open')) {
        this.drawer.classList.remove('is-open');
        this.drawer.classList.add('is-closing');
      }
    }

    setupFocusTrap() {
      if (!this.drawer) return;

      const focusableSelectors = [
        'button:not([disabled])',
        'input:not([disabled])',
        'select:not([disabled])',
        'textarea:not([disabled])',
        'a[href]',
        '[tabindex]:not([tabindex="-1"])'
      ];

      this.focusableElements = Array.from(
        this.drawer.querySelectorAll(focusableSelectors.join(', '))
      ).filter(el => {
        return el.offsetParent !== null && !el.hasAttribute('disabled');
      });
    }

    handleTabKey(e) {
      if (this.focusableElements.length === 0) return;

      const firstElement = this.focusableElements[0];
      const lastElement = this.focusableElements[this.focusableElements.length - 1];

      if (e.shiftKey) {
        // Shift + Tab
        if (document.activeElement === firstElement) {
          e.preventDefault();
          lastElement.focus();
        }
      } else {
        // Tab
        if (document.activeElement === lastElement) {
          e.preventDefault();
          firstElement.focus();
        }
      }
    }

    focusFirstElement() {
      if (this.focusableElements.length > 0) {
        this.focusableElements[0].focus();
      }
    }
  }

  // Classe para forçar empurramento de elementos quando subcoleção nested abre
  class NestedDropdownPusher {
    constructor() {
      this.init();
    }

    init() {
      this.setupNestedDropdownListeners();
    }

    setupNestedDropdownListeners() {
      document.addEventListener('click', (e) => {
        const nestedToggle = e.target.closest('.mobile-dropdown--nested .mobile-dropdown__toggle');
        if (nestedToggle) {
          setTimeout(() => {
            this.forceContentPush();
          }, 50);
        }
      });
    }

     forceContentPush() {
       // SIMPLIFICADO: Só forçar a expansão do conteúdo, sem mexer em posicionamento
    
       
       const openNestedDropdowns = document.querySelectorAll('.mobile-dropdown--nested .mobile-dropdown__toggle[aria-expanded="true"]');
       
       openNestedDropdowns.forEach(toggle => {
         const nestedContent = toggle.nextElementSibling;
         if (nestedContent && nestedContent.classList.contains('mobile-dropdown__content--nested')) {
           
           // APENAS propriedades essenciais - SEM POSICIONAMENTO
           nestedContent.style.height = 'auto';
           nestedContent.style.maxHeight = '60vh';
           nestedContent.style.display = 'block';
           
         }
       });
     }
  }

  // Inicializar o controlador do drawer mobile
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      new MobileDrawerController();
      new NestedDropdownPusher();
    });
  } else {
    new MobileDrawerController();
    new NestedDropdownPusher();
  }

  // ========================================
  // FIX: Preservar posição do scroll ao abrir carrinho
  // O código principal está em head.liquid
  // Este é apenas um backup adicional
  // ========================================
  
  // O fix principal já está rodando no HEAD via window.cartScrollFix
  // Nada mais precisa ser feito aqui

  // ========================================
  // FIX: Garantir que .pswp (PhotoSwipe zoom) existe no DOM
  // Caso o snippet zoom-pswp.liquid não tenha sido renderizado
  // ========================================
  (function ensurePswpElement() {
    function createPswp() {
      if (document.querySelector('.pswp')) return; // já existe, nada a fazer

      const pswp = document.createElement('div');
      pswp.className = 'pswp pswp--custom-loader';
      pswp.setAttribute('tabindex', '-1');
      pswp.setAttribute('role', 'dialog');
      pswp.setAttribute('aria-hidden', 'true');
      pswp.innerHTML = [
        '<div class="pswp__bg"></div>',
        '<div class="pswp__scroll-wrap">',
          '<div class="pswp__container">',
            '<div class="pswp__item"></div>',
            '<div class="pswp__item"></div>',
            '<div class="pswp__item"></div>',
          '</div>',
          '<div class="pswp__ui pswp__ui--hidden">',
            '<div class="pswp__top-bar">',
              '<div class="pswp__counter"></div>',
              '<button class="pswp__button pswp__button--close pswp__custom-close pswp__ui-over-close" title="Close (Esc)">',
                '<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" width="18" height="18">',
                  '<path d="M6 18L18 6M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>',
                '</svg>',
              '</button>',
              '<div class="pswp__preloader">',
                '<div class="pswp__preloader__icn">',
                  '<div class="pswp__preloader__cut">',
                    '<div class="pswp__preloader__donut"></div>',
                  '</div>',
                '</div>',
              '</div>',
            '</div>',
            '<div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">',
              '<div class="pswp__share-tooltip"></div>',
            '</div>',
            '<button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)">',
              '<svg viewBox="0 0 24 24" width="20" height="20"><path d="M15 18l-6-6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" fill="none"/></svg>',
            '</button>',
            '<button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)">',
              '<svg viewBox="0 0 24 24" width="20" height="20"><path d="M9 18l6-6-6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" fill="none"/></svg>',
            '</button>',
            '<div class="pswp__thumbs"></div>',
            '<div class="pswp__caption">',
              '<div class="pswp__caption__center"></div>',
              '<a href="#" class="pswp__caption-close">',
                '<svg viewBox="0 0 24 24" width="20" height="20"><path d="M15 18l-6-6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" fill="none"/></svg>',
              '</a>',
            '</div>',
          '</div>',
        '</div>'
      ].join('');

      document.body.appendChild(pswp);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', createPswp);
    } else {
      createPswp();
    }
  })();

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();